import Component from '@glimmer/component';
import {
  isAwsProviderNetwork,
  isAzureProviderNetwork,
} from 'networks-common/utils/networks';
import Aws from 'hcp/components/page/hvn-peerings/configuration-instructions/aws';
import Azure from 'hcp/components/page/hvn-peerings/configuration-instructions/azure';

/**
 *
 * `tab` will be the selected tab;
 * @argument tab;
 * @type {String}
 *
 */
/**
 *
 * `product` such as consul or vault;
 * @argument product;
 * @type {String}
 *
 */
/**
 *
 * `model` will be a model containing the peering detail;
 * @argument model;
 * @type {Object}
 *
 */
/**
 *
 * `PeeringConfigurationInstructions` renders the HVN Peerings Configuration instructions page.
 *
 *
 * ```
 * <Page::HvnPeerings::ConfigurationInstructions
 *   @model={{model}}
 *   @tab={{tab}}
 *   @product={{product}}
 * />
 * ```
 *
 * @class PeeringConfigurationInstructions
 *
 */
export default class PagePeeringConfigurationInstructions extends Component {
  get isAws() {
    return isAwsProviderNetwork(this.args.model.network);
  }
  get isAzure() {
    return isAzureProviderNetwork(this.args.model.network);
  }
  <template>
    {{#if this.isAws}}
      <Aws @model={{@model}} @tab={{@tab}} @product={{@product}} />
    {{else if this.isAzure}}
      <Azure @model={{@model}} @tab={{@tab}} @product={{@product}} />
    {{/if}}
  </template>
}
